import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Orb from "./Orb";
import { useTranslation } from "react-i18next";

// Hero slide data
const heroData = [
  {
    key: "book-kembar",
  },
  {
    key: "book-reja",
  },
  {
    key: "book-bira",
  },
  {
    key: "book-cimi",
  },
  {
    key: "book-gani",
  },
];

const StoryHeroList = () => {
  const { t } = useTranslation();
  return (
    <section className="py-5 story-hero-list" style={{ position: "relative" }}>
      <Container>
        <h2 className="text-center mb-5 section-title color-blue">{t("story-hero-list-title")}</h2>
        <Row className="justify-content-center text-center">
          <Orb color="rgb(139, 210, 211)" bottom="-30vh" right="-30vh" />

          {heroData.map((item) => (
            <Col sm={6} md={4} className="mb-4 d-flex flex-column align-items-center" key={item.key}>
              <Card
                className="border-0 text-center"
                style={{
                  width: "150px",
                  height: "200px",
                  backgroundColor: "#f0f0f0",
                }}
              ></Card>

              <div className="subsection-title" style={{ marginTop: "1rem" }}>
                {t(`${item.key}.title`)}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StoryHeroList;
